import React from "react";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

const SelectLingua = (props) => {
  return (
    <Select
      align="center"
      value={props.lingua}
      onChange={(e) => props.onCambioLingua(e.target.value)}
    >
      <MenuItem value="it">IT</MenuItem>
      <MenuItem value="en">EN</MenuItem>
    </Select>
  );
};

export default SelectLingua;
